import { ConfigProvider, Divider } from 'antd';
import React from 'react';

const BasicDivider = (props) => {
  return (
    <ConfigProvider
      theme={{
        token: {
            marginLG: 8
        }
      }}
    >
      <Divider {...props} />
    </ConfigProvider>
  );
};

export default BasicDivider;
